import React from 'react';
import AuthWrapper from '../components/molecules/AuthWrapper';
import QuizTemplate from '../components/templates/Quiz';

const Quiz = () => {
  return <AuthWrapper renderProps={QuizTemplate} />;
};

export default Quiz;
